import React from 'react'
import { ResumeLayout } from '../../partials/resume/resume-layout'
import { defaultState } from '../../state/values-reducer'

export const DefaultResumeLayout: React.FC = () => {
    return <ResumeLayout values={defaultState} />
}

export default DefaultResumeLayout;
